import * as io from 'io-ts';
var required = io.type({
  id: io.string,
  display_name: io.string
});
var optional = io.partial({});
export var Organization = io.intersection([required, optional]);